import React from "react";
import { Button, Divider, Header, Icon } from "semantic-ui-react";

import IParishMin from "../../../data/parish/ParishMin";
import { NewMainPlacement } from "../../../data/priest/MainPlacement";
import { NewPlacement } from "../../../data/priest/Placement";
import IPriestProfileData from "../../../data/priest/PriestProfileData";
import useFetchData from "../../../requests/useFetchData";
import BoldFM from "../../../util/styledMessages/BoldFM";
import ItalicFM from "../../../util/styledMessages/ItalicFM";
import ErrorMsg from "../../ErrorMsg";
import ProfilePlaceholder from "../../ProfilePlaceholder";
import PriestAssistantPriestPlaceList from "./PriestAssistantPriestPlaceList";
import PriestMainPriestPlaceList from "./PriestMainPriestPlaceList";

interface IPriestPlacementContainerProps {
    priest: IPriestProfileData;
    loading: boolean;
    showError: boolean;
    editMode: boolean;
    setPriest(newPriest: IPriestProfileData): void;
}

const PriestPlacementContainer: React.FC<IPriestPlacementContainerProps> = (props: IPriestPlacementContainerProps) => {
    const { priest, loading, showError, editMode, setPriest } = props;

    const { response: parishResponse, loading: parishLoading, showError: parishShowError } = useFetchData<IParishMin[]>("/parishes");

    const handleNewMainPlacement = () => {
        if (priest) {
            if (priest.mainPriestPlaces) {
                priest.mainPriestPlaces.splice(0, 0, { ...NewMainPlacement });
                setPriest({ ...priest, mainPriestPlaces: priest.mainPriestPlaces });
            } else {
                setPriest({ ...priest, mainPriestPlaces: [{ ...NewMainPlacement }] });
            }
        }
    };

    const handleNewAssistantPlacement = () => {
        if (priest) {
            if (priest.assistantPriestPlaces) {
                priest.assistantPriestPlaces.splice(0, 0, { ...NewPlacement });
                setPriest({ ...priest, assistantPriestPlaces: priest.assistantPriestPlaces });
            } else {
                setPriest({ ...priest, assistantPriestPlaces: [{ ...NewPlacement }] });
            }
        }
    };

    if (showError) {
        return <ErrorMsg errorMessage={"error.connection"} />;
    } else if (loading || !priest) {
        return <ProfilePlaceholder />;
    } else {
        return (
            <>
                <Header as="h2">
                    {priest.mainPriestPlaces && priest.mainPriestPlaces.length > 1 ? (
                        <ItalicFM id="profile.mainPriestPlaces" />
                    ) : (
                        <ItalicFM id="profile.mainPriestPlace" />
                    )}
                </Header>
                {editMode && (
                    <Button
                        basic
                        circular
                        color="violet"
                        icon
                        id="addNewMainPlacement"
                        labelPosition="left"
                        onClick={handleNewMainPlacement}
                        style={{ marginBottom: "2em" }}
                    >
                        <Icon color="violet" name="add" size="large" />
                        <BoldFM id="profile.addNewMainPlacement" />
                    </Button>
                )}
                <PriestMainPriestPlaceList
                    editMode={editMode}
                    parishLoading={parishLoading}
                    parishResponse={parishResponse}
                    parishShowError={parishShowError}
                    priest={priest}
                    setPriest={setPriest}
                />

                <Divider style={{ marginTop: "2em" }} />

                <Header as="h2">
                    {priest.assistantPriestPlaces && priest.assistantPriestPlaces.length > 1 ? (
                        <ItalicFM id="profile.assistantPriestPlaces" />
                    ) : (
                        <ItalicFM id="profile.assistantPriestPlace" />
                    )}
                </Header>
                {editMode && (
                    <Button
                        basic
                        circular
                        color="violet"
                        icon
                        id="addNewAssistantPlacement"
                        labelPosition="left"
                        onClick={handleNewAssistantPlacement}
                    >
                        <Icon color="violet" name="add" size="large" />
                        <BoldFM id="profile.addNewAssistantPlacement" />
                    </Button>
                )}
                <PriestAssistantPriestPlaceList
                    editMode={editMode}
                    parishLoading={parishLoading}
                    parishResponse={parishResponse}
                    parishShowError={parishShowError}
                    priest={priest}
                    setPriest={setPriest}
                />
            </>
        );
    }
};

export default PriestPlacementContainer;
